import { render, staticRenderFns } from "./StudentsHistory.vue?vue&type=template&id=55918857&scoped=true&"
import script from "./StudentsHistory.vue?vue&type=script&lang=js&"
export * from "./StudentsHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55918857",
  null
  
)

export default component.exports